import React from 'react';

const ManageOrder = () => {
    return (
        <div>
            <h2>manage Order for admin</h2>
        </div>
    );
};

export default ManageOrder;